// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataDividend_main__4NxvS"};